// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ya-z","heading":"za-z","screenReadersOnly":"Aa-z"};